<fs-dialog>
  <div class="fs-row.justify-end">
    <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close"
        type="button"
        tabindex="-1">
      <mat-icon>
        clear
      </mat-icon>
    </button>
  </div>
  <mat-card>
    <mat-card-content>
      @if (step === 0) {
        <app-organization-name
          [(environmentCreate)]="environmentCreate"
          (environmentCreateChange)="stepNext()">
        </app-organization-name>
      }
      @if (step === 1) {
        <app-address
          [(environmentCreate)]="environmentCreate"
          (environmentCreateChange)="stepNext()">
        </app-address>
      }
      @if (step === 2) {
        <app-contact-info
          [environmentCreate]="environmentCreate"
          (environmentCreateChange)="stepNext()">
        </app-contact-info>
      }
      @if (step === 3) {
        <app-diseases
          [environmentCreate]="environmentCreate"
          (completed)="close()">
        </app-diseases>
      }
      <app-progress [step]="step"></app-progress>
    </mat-card-content>
  </mat-card>
</fs-dialog>